import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";
import { IMAGES } from "../../lib/i18n";

export default function Solution() {
  const { t } = useLang();
  const c = t.solution;
  return (
    <section id="solucion" data-testid="solution-section" className="py-24 sm:py-32 border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
        </div>

        <div className="grid grid-cols-12 gap-x-6 gap-y-12 items-start">
          <Reveal className="col-span-12 lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={IMAGES.orchard} alt={c.captions.imageAlt} className="w-full h-full object-cover" />
            </div>
            <div className="mt-4 font-mono text-[10px] tracking-[0.3em] uppercase text-olive-soft flex justify-between">
              <span>{c.captions.leftLabel}</span>
              <span>{c.captions.rightLabel}</span>
            </div>
          </Reveal>

          <div className="col-span-12 lg:col-span-7 lg:pl-6">
            <Reveal>
              <p className="text-lg text-olive-soft leading-relaxed mb-6">{c.body}</p>
            </Reveal>
            {c.note && (
              <Reveal>
                <p data-testid="solution-note" className="border-l-2 border-terracotta pl-5 py-1 text-sm text-olive italic font-serif mb-10">
                  {c.note}
                </p>
              </Reveal>
            )}
            <ul className="flex flex-col gap-5 mb-12">
              {c.bullets.map((b, i) => (
                <Reveal key={i} delay={i * 60} as="li" className="flex items-baseline gap-4 border-t border-border pt-4">
                  <span className="font-mono text-[10px] text-terracotta">0{i + 1}</span>
                  <span className="font-serif text-xl sm:text-2xl text-olive leading-snug">{b}</span>
                </Reveal>
              ))}
            </ul>

            <Reveal>
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-olive-soft mb-5">
                {c.structureTitle}
              </div>
              <div className="grid grid-cols-2 gap-px bg-border">
                {c.structure.map((s, i) => (
                  <div
                    key={i}
                    data-testid={`solution-struct-${i}`}
                    className="bg-ivory p-5"
                  >
                    <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-2">
                      {s.tag}
                    </div>
                    <div className="font-display text-2xl text-olive leading-tight mb-1">{s.title}</div>
                    <div className="text-sm text-olive-soft">{s.body}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
